import { ITextBoxProps } from 'store/ducks/Tasks/types';
import styled from 'styled-components';

interface IStyledBoxProps extends ITextBoxProps {
  scheme?: string;
}

export const StyledBox = styled('div')<IStyledBoxProps>`
  color: ${(props) =>
    ['deepNavyTheme', 'pinkUITheme', 'bluishTheme', 'lightUITheme'].includes(
      props.scheme || ''
    )
      ? '#000000 !important'
      : props.token.colorPrimaryText} !important;
  padding: ${(props) => `${props.token.padding}px`};
  background: ${(props) => props.token.colorFillContent};
  border-radius: 8px;
  margin-bottom: ${(props) => `${props.token.borderRadiusMD}px`};
  font-size: 16px;

  width: ${({ width }) => (width ? `${width}px` : '100%')};
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 10px;
`;
